import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { LoginScreen } from '@/pages/auth/LoginScreen'
import { BlogScreen } from '@/pages/blog/BlogScreen'
import { ChatScreen } from '@/pages/chat/ChatScreen'
import { BlogPostScreen } from '@/pages/blog/BlogPostScreen'
import { LibraryScreen } from '@/pages/library/LibraryScreen'
import { LibraryDocumentScreen } from '@/pages/library/LibraryDocumentScreen'
import { SettingsScreen } from '@/pages/Settings'
import RegisterQuestionnaire from '@/pages/RegisterQuestionnaire'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import TermsPage from '@/pages/legal/TermsPage'
import PrivacyPage from '@/pages/legal/PrivacyPage'
import DeleteAccountPage from '@/pages/legal/DeleteAccountPage'
import { SharedConversationPage } from '@/pages/SharedConversationPage'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { Layout } from '@/components/layout/Layout'
import { ThemeProvider } from '@/contexts/ThemeContext'

// Helper function para determinar página atual
function getCurrentPage(pathname: string): 'feed' | 'chat' | 'blog' | 'biblioteca' { // | 'marketplace'
  if (pathname.startsWith('/blog')) return 'blog'
  if (pathname.startsWith('/biblioteca')) return 'biblioteca'
  // if (pathname.startsWith('/marketplace')) return 'marketplace'
  if (pathname.startsWith('/chat')) return 'chat'
  return 'chat'
}

function AppContent() {
  const location = useLocation()
  const currentPage = getCurrentPage(location.pathname)

  // Rotas que NÃO devem ter Layout
  const noLayoutRoutes = ['/login', '/register', '/forgot-password', '/reset-password', '/terms', '/privacy', '/excluir-conta']
  const isSharedRoute = location.pathname.startsWith('/shared/') // '/register' e '/forgot-password' comentados temporariamente
  const shouldShowLayout = !noLayoutRoutes.includes(location.pathname) && !isSharedRoute

  return (
    <>
      {shouldShowLayout ? (
        <Layout currentPage={currentPage}>
          <Routes>
            {/* Protected routes */}
            <Route path="/chat" element={
              <ProtectedRoute>
                <ChatScreen />
              </ProtectedRoute>
            } />
            <Route path="/blog" element={<BlogScreen />} />
            <Route path="/blog/:slug" element={<BlogPostScreen />} />
            <Route path="/biblioteca" element={
              <ProtectedRoute>
                <LibraryScreen />
              </ProtectedRoute>
            } />
            <Route path="/biblioteca/:slug" element={
              <ProtectedRoute>
                <LibraryDocumentScreen />
              </ProtectedRoute>
            } />
            {/* <Route path="/marketplace" element={
              <ProtectedRoute>
                <FeedScreen />
              </ProtectedRoute>
            } />
            <Route path="/marketplace/:id" element={
              <ProtectedRoute>
                <ContentDetailScreen />
              </ProtectedRoute>
            } /> */}
            <Route path="/settings" element={
              <ProtectedRoute>
                <SettingsScreen />
              </ProtectedRoute>
            } />
            <Route path="/register-questionnaire" element={<RegisterQuestionnaire />} />

            {/* Default redirect — Chat is the landing page */}
            <Route path="/" element={
              <ProtectedRoute>
                <ChatScreen />
              </ProtectedRoute>
            } />
          </Routes>
        </Layout>
      ) : (
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/register" element={<RegisterQuestionnaire />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/excluir-conta" element={<DeleteAccountPage />} />
          <Route path="/shared/:token" element={<SharedConversationPage />} />
        </Routes>
      )}
    </>
  )
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App